/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import './svg-inject';

jQuery(document).ready($ => {
  // prevent body scrolling when dropdown active
  $('.navbar-toggler').click(() => {
    $('body').toggleClass('locked');
  });

  $(document).ready(() => {
    $('.ddp__section.accordion').prev('.ddp__section').addClass('before-accordion');
  });

  // Fancybox
  Fancybox.bind('[data-fancybox]', {
    mainClass: 'team__container'
  });

  // scroll to top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
      $('header .navbar').addClass('shrink');
    } else {
      $('header .navbar').removeClass('shrink');
    }
  });

  // Überprüfen, ob die Klasse ".cookies" vorhanden ist
  if ($('footer .cookies').length > 0) {
    // Wenn die Klasse gefunden wurde, fügen Sie das data-Attribut hinzu
    $('footer .cookies a').attr('data-cc', 'c-settings');
  }

  // scroll to top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 850) {
      $('.footer__top_scroll').fadeIn();
    } else {
      $('.footer__top_scroll').fadeOut();
    }
  });

  $('.footer__top_scroll a').click(() => {
    $('html, body').animate(
      {
        scrollTop: 0
      },
      600
    );
    return false;
  });

  $('.servicebox li.label').click(function () {
    const label = $(this).data('label');
    $('.servicebox__image .content').removeClass('active');
    $('.servicebox .imagebox').hide();

    $('.servicebox__image .content').each(function (index) {
      const content = $(this).data('content');
      if (label === content) {
        $(this).addClass('active');
      }
    });
  });

  // sticky on scroll
  let stickyElement = $('.navbar'),
    stickyClass = 'fixed',
    stickyPos = stickyElement.offset().top,
    stickyHeight;

  function stickerFn() {
    const winTop = $(this).scrollTop();
    winTop >= stickyPos ? stickyElement.addClass(stickyClass) : stickyElement.removeClass(stickyClass);
  }
  stickerFn();

  $(window).scroll(() => {
    stickerFn();
  });

  stickyElement.after('<div class="navbar__prevent"></div>');

  function jumpsPrevent() {
    stickyHeight = stickyElement.innerHeight();
    stickyElement.css({ 'margin-bottom': '-' + stickyHeight + 'px' });
    stickyElement.next().css({ 'padding-top': +stickyHeight + 'px' });
  }
  jumpsPrevent();

  $(window).resize(() => {
    jumpsPrevent();
  });

  Fancybox.bind('[data-fancybox]', {
    hideScrollbar: false
  });

  $('.team__overlay .close .btn').click(() => {
    Fancybox.close();
  });

  // init slider
  if ($('.stage__slider').length > 0) {
    const oc = $('.stage__slider');
    const ocOptions = oc.data('carousel-options');
    const defaults = {
      loop: false,
      rewind: true,
      autoplay: true,
      autoplayTimeout: 10000,
      autoplayHoverPause: true,
      touchDrag: false,
      mouseDrag: false,
      dots: true,
      dotsContainer: '.ddp__dots .owl-dots',
      nav: false,
      margin: 0,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        991: {
          items: 1
        }
      }
    };
    oc.owlCarousel($.extend(defaults, ocOptions));
  }

  // init slider
  if ($('.keyword__slider').length > 0) {
    const oc = $('.keyword__slider');
    const ocOptions = oc.data('carousel-options');
    const defaults = {
      loop: false,
      rewind: true,
      autoplay: true,
      autoplayTimeout: 10000,
      autoplayHoverPause: true,
      mouseDrag: true,
      dots: true,
      dotsContainer: '.keyword__dots .owl-dots',
      nav: false,
      margin: 50,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        991: {
          items: 3
        }
      }
    };
    oc.owlCarousel($.extend(defaults, ocOptions));
  }

  // init slider
  if ($('.slider__box').length > 0) {
    const oc = $('.slider__box');
    const ocOptions = oc.data('carousel-options');
    const defaults = {
      loop: false,
      rewind: true,
      navText: [
        '<img width=\'36\' height=\'36\' class=\'svg\' src=\'/wp-content/themes/ddpgruppe-website/dist/images/icons/arrow-left.svg\'>',
        '<img width=\'36\' height=\'36\' class=\'svg\' src=\'/wp-content/themes/ddpgruppe-website/dist/images/icons/arrow-right.svg\'>'
      ],
      autoplay: true,
      autoplayTimeout: 10000,
      autoplayHoverPause: true,
      margin: 100,
      dots: true,
      dotsContainer: '.sliderbox__dots .owl-dots',
      navContainer: '.sliderbox__nav .owl-nav',
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        },
        991: {
          items: 1
        }
      }
    };
    oc.owlCarousel($.extend(defaults, ocOptions));
  }

  // Back Button
  const $backButton = $('#goBackButton');
  if ($backButton.length > 0) {
    $backButton.on('click', () => {
      window.history.back();
    });
  }

  // svg inject

  // Select all images with the 'svg' class
  const svgImages = document.querySelectorAll('img.svg');

  // Filter those images to include only ones with a '.svg' in their src attribute
  const filteredSvgImages = Array.from(svgImages).filter(img => img.src.endsWith('.svg'));

  // Inject SVG only if filtered images exist
  if (filteredSvgImages.length > 0) {
    SVGInject(filteredSvgImages);
  }

  // toggle
  $('.accordion__content__item_question.has_content').click(function () {
    $(this).toggleClass('active');
    $(this).next('.accordion__content__item').slideToggle('collapse');
  });

  // smooth scroll
  $('.scroll').click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      && location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      let target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate(
          {
            scrollTop: target.offset().top - 120
          },
          1000,
          () => {
            // Callback after animation
            // Must change focus!
            const $target = $(target);
            $target.focus();
            if ($target.is(':focus')) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }
    }
  });

  // Back to Top Button functionality
  const backToTopButton = $('#back-to-top');

  // Show/hide button based on scroll position
  $(window).scroll(function backToTopScroll() {
    if ($(this).scrollTop() > 400) {
      backToTopButton.addClass('show');
    } else {
      backToTopButton.removeClass('show');
    }
  });

  // Smooth scroll to top when button is clicked
  backToTopButton.click(e => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 200);
  });

  // Handle keyboard navigation for accessibility
  backToTopButton.keydown(e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(e.target).click();
    }
  });
});
